<template>
  <div>
    <p>actigraphy loading</p>
  </div>
</template>

<script>
export default {
name: "ActigraphyChartWidgetSkeleton"
}
</script>

<style scoped>

</style>